import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Common Number", to: "/common-numbers" },
  { label: "Dream Number", to: "/dream-numbers" },
  { label: "Previous Result", to: "/previous-result" },
  { label: "Analytics", to: "/analytics" },
  { label: "Predict Target", to: "/predict-target" },
  { label: "Teer Calendar", to: "/calendar" },
  { label: "Teer Counter", to: "/teer-counter" },
  { label: "Teer Aacharya", to: "/teer-aacharya" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms & Conditions", to: "/terms" },
];

const Header = ({ title }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const go = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <>
      {/* Blue logo bar */}
      <div className="w-full bg-[#a9cce8] border-b border-[#8fb8dc]">
        <div className="max-w-3xl mx-auto flex items-center justify-between px-4 py-3">
          <Link to="/" className="flex items-center">
            <Logo />
          </Link>
          <button
            aria-label="Menu"
            onClick={() => setOpen(true)}
            className="p-2 rounded-md hover:bg-[#96bfe0] transition-colors"
          >
            <Menu className="w-7 h-7 text-[#2c3e50]" strokeWidth={2.5} />
          </button>
        </div>
      </div>

      {/* Optional secondary title bar (used on inner/admin pages) */}
      {title && (
        <div className="w-full bg-[#eef1f4] border-b border-[#dfe3e8]">
          <div className="max-w-3xl mx-auto px-4 py-3">
            <h1 className="text-2xl font-medium text-[#5b6b7b]">{title}</h1>
          </div>
        </div>
      )}

      {/* Slide-out menu */}
      {open && (
        <div className="fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setOpen(false)}
          />
          <div className="absolute top-0 left-0 h-full w-72 bg-white shadow-xl flex flex-col animate-in slide-in-from-left duration-200">
            <div className="flex items-center justify-between px-4 py-4 bg-[#a9cce8]">
              <span className="font-bold text-[#2c3e50]">Menu</span>
              <button onClick={() => setOpen(false)} aria-label="Close">
                <X className="w-6 h-6 text-[#2c3e50]" />
              </button>
            </div>
            <nav className="flex-1 overflow-y-auto py-2">
              {navLinks.map((l) => (
                <button
                  key={l.to}
                  onClick={() => go(l.to)}
                  className="w-full text-left px-5 py-3 text-[15px] text-[#374151] hover:bg-[#f1f5f9] border-b border-gray-100 transition-colors"
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
